module.exports = {
  devBaseURL: "http://localhost:4000/",
  prodBaseURL: "/proxy/",
  backendProxyTarget: "http://localhost:4000",
  secretKey: "5TIvw5cpc0",
  projectName: "IndSparkTube",
  folderStructurePath: "IndSparkTube",
  bucketName: "indsparktubebucket",
  hostname: "https://blr1.digitaloceanspaces.com",
  aws_access_key_id: "DO801FHX4WN7MBH47MKN",
  aws_secret_access_key: "D1EDCw5yKuVEDhyXmnTrKbxDAOprR3aKszrwcOM+zFE",
};
